import React, { Suspense, lazy } from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Loading from './components/Loading'

const LoginPage = lazy(() => import('./pages/LoginPage'))
const RegisterPage = lazy(() => import('./pages/RegisterPage'))
const ProfilePage = lazy(() => import('./pages/ProfilePage'))
const PostPage = lazy(() => import('./pages/PostPage'))
const CreatePostPage = lazy(() => import('./pages/CreatePostPage'))
const CommunityPage = lazy(() => import('./pages/CommunityPage'))
const WelcomePage = lazy(() => import('./pages/WelcomePage'))
const SimpleCreatePage = lazy(() => import('./pages/SimpleCreatePage'))
const LibraryPage = lazy(() => import('./pages/LibraryPage'))
const YouPage = lazy(() => import('./pages/YouPage'))
const ReadingPage = lazy(() => import('./pages/ReadingPage'))
const TonightPage = lazy(() => import('./pages/TonightPage'))
const BedtimeEditPage = lazy(() => import('./pages/BedtimeEditPage'))
const ActivationPage = lazy(() => import('./pages/ActivationPage'))
const BlogPage = lazy(() => import('./pages/BlogPage'))
const Membership = lazy(() => import('./pages/Membership'))
const MembershipSuccess = lazy(() => import('./pages/MembershipSuccess'))
const Terms = lazy(() => import('./pages/Terms'))
const Privacy = lazy(() => import('./pages/Privacy'))
const AboutPage = lazy(() => import('./pages/AboutPage'))
const SettingsPage = lazy(() => import('./pages/SettingsPage'))
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'))
const ResetPage = lazy(() => import('./pages/ResetPage'))

const HomeOrRedirect = () => {
  const user = useSelector((state) => state.user)
  if (user) return <Redirect to="/tonight" />
  return <WelcomePage />
}

const ProfileRoute = ({ match }) => {
  const user = useSelector(state => state.user)
  return user?.username === match.params.id ? <YouPage /> : <ProfilePage />
}

const DraftRoute = withRouter((props) => (
  <div>
    {props.location.draftProps !== undefined ? (
      <Route path="/draft" render={() => <CreatePostPage />} exact />
    ) : (
      <Redirect to="/" />
    )}
  </div>
))

const Routes = () => (
  <Suspense fallback={<Loading />}>
    <Switch>
      <Route path="/" render={() => <HomeOrRedirect />} exact />
      <Route path="/tonight" render={() => <TonightPage />} exact />
      <Route path="/library" render={() => <LibraryPage />} exact />
      <Route path="/planner" render={() => <Redirect to="/tonight" />} exact />
      <Route path="/you" render={() => <YouPage />} exact />
      <Route path="/profile" render={() => <YouPage />} exact />
      <Route path="/settings" render={() => <SettingsPage />} exact />
      <Route path="/community" render={() => <CommunityPage />} exact />
      <Route path="/profile/:id" component={ProfileRoute} exact />
      <Route path="/activate/:token" render={() => <ActivationPage />} exact />
      <Route path="/reset/:token" render={() => <ResetPage />} exact />
      <Route path="/story/create" render={({ location }) => new URLSearchParams(location.search).get('mode') === 'advanced' ? <CreatePostPage /> : <SimpleCreatePage />} exact />
      <Route path="/story/:id/edit" render={() => <BedtimeEditPage />} exact />
      <Route path="/story/:id" render={({ location }) => new URLSearchParams(location.search).get('view') === 'details' ? <PostPage /> : <ReadingPage />} exact />
      <Route path="/storyworld" render={() => <BlogPage />} exact />
      <Route path="/stories" render={() => <Redirect to="/blog" />} exact />
      <Route path="/blog" render={() => <BlogPage />} exact />
      <Route path="/blog/:slug" render={() => <BlogPage />} exact />
      <Route path="/membership/success" render={() => <MembershipSuccess />} exact />
      <Route path="/membership" render={() => <Membership />} exact />
      <Route path="/subscription" render={() => <Redirect to="/membership" />} exact />
      <Route path="/terms" render={() => <Terms />} exact />
      <Route path="/privacy" render={() => <Privacy />} exact />
      <Route path="/about" render={() => <AboutPage />} exact />
      <Route path="/login" render={() => <LoginPage />} exact />
      <Route path="/register" render={() => <RegisterPage />} exact />
      <DraftRoute />
      <Route render={() => <NotFoundPage />} />
    </Switch>
  </Suspense>
)

export default Routes
